<template>
<v-app id="inspire">
   <nav>
   <v-toolbar>
     <v-toolbar-title class="headline text-uppercase">
       <span>GEM</span>
     </v-toolbar-title>
     <v-spacer></v-spacer>
   </v-toolbar>
 </nav>
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                id="LoginToolbar"
              >
                <v-toolbar-title style="color: white;">Login</v-toolbar-title>
                <div class="flex-grow-1"></div>

              </v-toolbar>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation>
                    <v-text-field
                      ref="username"
                      v-model="username"
                      :rules="[() => !!username || 'This field is required']"
                      prepend-icon="mdi-account"
                      label="Login"
                      placeholder="Please enter your username"
                      required
                    />
                    <v-text-field
                      ref="password"
                      v-model="password"
                      :rules="[() => !!password || 'This field is required']"
                      :type="showPassword ? 'text' : 'password'"
                      prepend-icon="mdi-lock"
                      label="Password"
                      placeholder="*********"
                      required
                      @keydown.enter="login"
                    />
                  </v-form>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="primary" @click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-snackbar
        v-model="snackbar"
        :color="color"
        :top='true'
      >
        {{ errorMessages }}
        <v-btn
          dark

          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<style>
#LoginToolbar{

  background-image: linear-gradient(to right, #040576, #330d89, #53179c, #7121af, #8f2cc2, #9037c9, #9041d1, #914ad8, #7450d3, #5654cb, #3555c1, #0055b5);
}
</style>
<script>


export default {
  data: function () {
    return {
      username: '',
      password: '',
      errorMessages: 'Incorrect login info',
      snackbar: false,
      color: 'general',
      valid: '',
      showPassword: false
    }
  },
  methods: {
    login: function () {
      let username = this.username
      let password = this.password
      if (this.$refs.form.validate()) {
          this.$store.dispatch('login', { username, password })
            .then( () => {

              if(localStorage.getItem('permission') == "finance"){
                console.log("INSIDE IF")
                                this.$router.push({ name: 'Invoices'})

              }else{
                              this.$router.go('/')
              }
            }

            )
            .catch(() => {
            this.snackbar= true
            })
      }else {
        this.errorMessages = "Kindly fill in both fields"
        this.snackbar= true
      }
    }
  },
  metaInfo () {
    return {
      title: 'BackTrack | Login'
    }
  }
}
</script>